export const colors = {
    PRIMARY: "#52b788",
    SECONDARY: "#343233",
    TERTIARY: "#E8E8E8",
    BACKGROUND: "#FFFFFF",
    BACKGROUND2: "#52b788",
    RED: "#E72424",
    GREEN: "#15b138"
}